import React from 'react'
import { useTranslation } from 'react-i18next'
import { PermissionsKey } from '../../data/permissions'

type Props ={
    label:PermissionsKey
}

export default function PermissionLable({label}:Props) {
  const { t } = useTranslation(); 
return <span>{t(`permissions:${label}` as any)}</span>;
}
